export enum EngagementTypeEnum {
  Segment = 1,
  Playlist = 2
}

export enum EngagementTypeStringEnum {
  Segment = 'Segment',
  Playlist = 'Playlist'
}